import { InventoryFilters } from '../../types';

export const emptyFilters: InventoryFilters = {
  customPartNumber: '',
  material: null,
  numberOfConductors: null,
  partNumber: '',
  productType: null,
  productSubType: null,
  searchByCable: true,
  standardType: null,
  gauge: null,
  voltage: null,
};

export type PageParameters = {
  type: 'csa' | 'ul';
};
